import React, { Fragment } from 'react'
import { withRouteData, Head } from 'react-static'
import cx from 'classnames'

import { SITE_CONSTANTS } from '../../../utils/constants'

import CardTrialv2 from '../../../blocks/CardFooter/CardTrialv2'
import Footer from '../../../blocks/NewFooter/NewFooterV2'

import '../../landingPages.scss'

export default withRouteData(({ b2b, card, children, hero, headData, distribuidor, footerCTAText, representative, marketplace, industry }) => (
    <Fragment>
        {headData && <Head>
            <title>{headData.pageTitle}</title>
            <meta property="og:title" content={headData.pageTitle} />
            <meta name="twitter:title" content={headData.pageTitle} />
            <meta name="description" content={headData.pageDescription} />
            <meta property="og:description" content={headData.pageDescription} />
            <meta name="twitter:description" content={headData.pageDescription} />
            <meta property="og:image" content={headData.ogImage} />
            <meta name="twitter:image" content={headData.ogImage} />
            <meta property="og:url" content={headData.ogUrl} />
            <link rel="canonical" href={headData.ogUrl} />

            {headData.noFollow && (
                <meta name="robots" content="noindex,nofollow" />
            )}


        </Head>}

        <div className={`new-layout new-landing-page ${b2b ? 'new-landing-page-b2b' : ''} ${marketplace ? 'marketplace-partner' : ''}`}>
            {children}
        </div>


        {representative ? '' : (
            <CardTrialv2 className="card-trial-landing-pages" trialText='comece grátis' isEcommerce
                text={
                    b2b ? 'Todos os dias milhares de varejistas já compram online por catálogo B2B. Não fique para trás.' :
                        distribuidor
                            ? `Comece a usar o sistema para distribuidoras que já potencializou o processo comercial de mais de ${SITE_CONSTANTS.CLIENTS_COUNT} empresas`
                            : industry
                                ? `Comece a usar o sistema para indústrias que já potencializou o processo comercial de mais de ${SITE_CONSTANTS.CLIENTS_COUNT_WITH_COMMA} empresas`
                                : footerCTAText
                                    ? footerCTAText
                                    : `Junte-se a mais de 35 mil diretores comerciais, gerentes e representantes que estão potencializando e gerenciando suas vendas`
                }
            />
        )}


        <Footer />
    </Fragment>
))



// WEBPACK FOOTER //
// /usr/src/site-blog/src/containers/site/landing-pages/TemplateLandingPage.jsx